import { render, staticRenderFns } from "./AffiliatesTable.vue?vue&type=template&id=af71b908&scoped=true&"
import script from "./AffiliatesTable.vue?vue&type=script&lang=js&"
export * from "./AffiliatesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af71b908",
  null
  
)

export default component.exports